import detail from "@/pages/detail/detail";
import info from "@/pages/detail/info/info";
import pic from "@/pages/pic/pic";
import Vue from "vue";
import Router from "vue-router";
import { applySeo, setJsonLd, removeJsonLd, toAbsoluteUrl } from "@/utils/seo";

// 聚合签到详情页使用按需加载，避免普通签到详情首屏额外打包少见场景代码。
const detailAggregate = () => import("@/pages/detailaggregate");
const certStatus = () => import("@/pages/cert/certStatus");
const chooseMode = () => import("@/pages/cert/chooseMode");
const ads = () => import("@/pages/cert/ads");
const wxlogin = () => import("@/pages/wxlogin");
const checkIn = () => import("@/pages/checkin");
const video = () => import("@/pages/video");
const success = () => import("@/pages/detail/success");
const download = () => import("@/pages/detail/download");
const shareImg = () => import("@/pages/detail/shareimg");
const rank = () => import("@/pages/detail/rank");
const workrank = () => import("@/pages/detail/workrank");
const allwork = () => import("@/pages/detail/allwork");
const workdetail = () => import("@/pages/detail/workdetail");
const userCheckin = () => import("@/pages/usercheckin");
const attendance = () => import("@/pages/cert/attendance");
const team = () => import("@/pages/cert/team");
const shareVip = () => import("@/pages/cert/sharevip");
const protocol = () => import("@/pages/cert/protocol");
const myCheckin = () => import("@/pages/mycheckin");
const myCheckinSearch = () => import("@/pages/mycheckin/search");
const createDefault = () => import("@/pages/createdefault");
const personal = () => import("@/pages/userCenter/personal");
const personalRecords = () => import("@/pages/userCenter/personalRecords");
const webguide = () => import("@/pages/userCenter/webguide");
const notice = () => import("@/pages/notice");
const noticeList = () => import("@/pages/notice/list");
const commentReply = () => import("@/pages/comment/reply");
const notFound = () => import("@/pages/notfound");

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "createDefaultRoot",
      // 根路径直接复用新建签到组件，访问 / 时保持地址不变。
      component: createDefault,
      meta: { title: "新建签到" }
    },
    {
      path: "/wxlogin",
      name: "wxlogin",
      component: wxlogin
    },
    {
      path: "/checkin",
      name: "checkin",
      component: checkIn
    },
    {
      path: "/success",
      name: "success",
      component: success
    },
    {
      path: "/download",
      name: "download",
      component: download
    },
    {
      path: "/shareimg",
      name: "shareImg",
      component: shareImg
    },
    {
      path: "/rank",
      name: "rank",
      component: rank
    },
    {
      path: "/workrank",
      name: "workrank",
      component: workrank
    },
    {
      path: "/allwork",
      name: "allwork",
      component: allwork
    },
    {
      path: "/workdetail",
      name: "workdetail",
      component: workdetail
    },
    {
      path: "/video",
      name: "video",
      component: video
    },
    {
      path: "/detail",
      name: "detail",
      component: detail
    },
    {
      path: "/detailaggregate",
      name: "detailAggregate",
      component: detailAggregate,
      meta: { title: "聚合签到详情" }
    },
    {
      path: "/info",
      name: "info",
      component: info
    },
    {
      path: "/pic",
      name: "pic",
      component: pic
    },
    {
      path: "/usercheckin",
      name: "userCheckin",
      component: userCheckin
    },
    {
      path: "/mycheckin",
      name: "myCheckin",
      component: myCheckin,
      meta: { title: "我的签到" }
    },
    {
      path: "/mycheckin/search",
      name: "myCheckinSearch",
      component: myCheckinSearch,
      meta: { title: "搜索签到" }
    },
    {
      path: "/createdefault",
      name: "createDefault",
      component: createDefault,
      meta: { title: "新建签到" }
    },
    {
      path: "/notice",
      name: "notice",
      component: notice,
      meta: { title: "审核通知" }
    },
    {
      path: "/notice/list",
      name: "noticeList",
      component: noticeList,
      meta: { title: "消息列表" }
    },
    {
      path: "/comment/reply",
      name: "commentReply",
      component: commentReply,
      meta: { title: "回复评论" }
    },
    {
      path: "/personal",
      name: "personal",
      component: personal,
      meta: { title: "个人中心" }
    },
    {
      path: "/personal/records",
      name: "personalRecords",
      component: personalRecords,
      meta: { title: "签到记录" }
    },
    {
      path: "/webguide",
      name: "webguide",
      component: webguide,
      meta: { title: "电脑端使用指南" }
    },
    {
      path: "/cert/certstatus",
      name: "certStatus",
      component: certStatus,
      meta: { title: "认证状态页" }
    },
    {
      path: "/cert/attendance",
      name: "attendance",
      component: attendance,
      meta: { title: "立吉拍照认证" }
    },
    {
      path: "/cert/team",
      name: "team",
      component: team
    },
    {
      path: "/cert/sharevip",
      name: "sharevip",
      component: shareVip
    },
    {
      path: "/cert/protocol",
      name: "protocol",
      component: protocol,
      meta: { title: "立吉拍照服务协议" }
    },
    {
      path: "/cert/choosemode",
      name: "chooseMode",
      component: chooseMode,
      meta: { title: "选择模式" }
    },
    {
      path: "/cert/ads",
      name: "ads",
      component: ads,
      meta: { title: "屏蔽广告" }
    },
    {
      path: "/404",
      name: "notFound",
      component: notFound,
      meta: {
        title: "页面找不到了 - 小小签到",
        description: "访问的页面不存在，请返回我的签到记录或前往认证页面。",
      }
    },
    {
      path: "*",
      redirect: "/404"
    }
  ],
  mode: "history", //后端支持可开
  // 测试环境以 /test 作为路由基准，生产环境保持根路径。
  base: process.env.NODE_ENV === "testing" ? "/test/" : "/",
  scrollBehavior: () => ({ y: 0 })
});

const ROUTE_SEO_CONFIG = {
  "/": {
    title: "新建签到 - 小小签到",
    description: "选择普通签到、扫码签到、考勤签到、会议签到和模板签到，快速前往小小签到小程序创建活动。",
    robots: "index,follow",
    canonicalPath: "/"
  },
  "/detail": {
    title: "签到详情 - 小小签到",
    description: "查看签到活动详情、签到时间、参与规则和动态记录。",
    robots: "index,follow",
    canonicalPath: "/detail"
  },
  "/detailaggregate": {
    title: "聚合签到详情 - 小小签到",
    description: "查看聚合签到详情，以及聚合签到中包含的签到活动。",
    robots: "index,follow",
    canonicalPath: "/detailaggregate"
  },
  "/cert/certstatus": {
    title: "发起人认证 - 小小签到",
    description: "小小签到发起人认证说明、权益介绍与认证状态查询入口。",
    robots: "index,follow",
    canonicalPath: "/cert/certstatus"
  },
  "/createdefault": {
    title: "新建签到 - 小小签到",
    description: "选择普通签到、扫码签到、考勤签到、会议签到和模板签到，快速前往小小签到小程序创建活动。",
    robots: "index,follow",
    canonicalPath: "/createdefault"
  },
  "/notice": {
    title: "审核通知 - 小小签到",
    description: "查看小小签到官方消息、评论消息、审核消息和赞赏消息。",
    robots: "noindex,nofollow",
    canonicalPath: "/notice"
  },
  "/comment/reply": {
    title: "回复评论 - 小小签到",
    description: "回复小小签到评论消息。",
    robots: "noindex,nofollow",
    canonicalPath: "/comment/reply"
  },
  "/404": {
    title: "页面找不到了 - 小小签到",
    description: "访问的页面不存在，请返回我的签到记录或前往认证页面。",
    robots: "noindex,nofollow",
    canonicalPath: "/404"
  }
};

// 站点级 description 兜底，防止路由未配置时出现描述缺失。
const DEFAULT_ROUTE_DESCRIPTION =
  "小小签到是一款专业免费的打卡签到小程序，支持活动签到、会议签到、班级签到、社群打卡和日常考勤等多场景使用。";

// 统一规范 query 值：当同名参数被解析成数组时，只取首个值参与 SEO/路由判断。
function normalizeQueryValue(value) {
  return Array.isArray(value) ? value[0] : value;
}

// 依据当前路由生成 SEO 配置（title/description/robots/canonical/ogType）。
function getRouteSeoConfig(to) {
  const routeConfig = ROUTE_SEO_CONFIG[to.path] || {};
  const title =
    routeConfig.title || (to.meta && to.meta.title) || "小小签到";
  const routeDescription =
    routeConfig.description ||
    (to.meta && to.meta.description) ||
    (title ? `${title}，来自小小签到。` : DEFAULT_ROUTE_DESCRIPTION);
  const showQr = normalizeQueryValue(to.query && to.query.showqr);
  let robots = routeConfig.robots || "index,follow";
  // showqr=1 往往是弹窗/私有流程入口，不希望被搜索引擎收录。
  if ((to.path === "/cert/certstatus" || to.path === "/") && String(showQr) === "1") {
    robots = "noindex,nofollow";
  }
  return {
    title,
    description: routeDescription,
    robots,
    canonical: toAbsoluteUrl(routeConfig.canonicalPath || to.path),
    ogType: "website"
  };
}

// 生成路由级 WebPage JSON-LD，作为页面未自行注入结构化数据时的兜底。
function buildRouteJsonLd(to, seoConfig) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: seoConfig.title || "小小签到",
    description: seoConfig.description || DEFAULT_ROUTE_DESCRIPTION,
    url: seoConfig.canonical || toAbsoluteUrl(to.path),
    isPartOf: {
      "@type": "WebSite",
      name: "小小签到",
      url: toAbsoluteUrl("/")
    }
  };
}

// 进入路由前做参数规范化：支持历史短链参数 mid，并统一改写到 /detail?cid=xxx。
router.beforeEach((to, from, next) => {
  if (to.path === "/") {
    const wid = normalizeQueryValue(to.query && to.query.wid);
    const cid = normalizeQueryValue(to.query && to.query.cid);
    const mid = normalizeQueryValue(to.query && to.query.mid);

    if (wid) {
      const query = Object.assign({}, to.query, {
        wid
      });
      next({
        path: "/workdetail",
        query,
        replace: true
      });
      return;
    }

    if (cid || mid) {
      const query = Object.assign({}, to.query, {
        cid: cid || mid
      });
      delete query.mid;
      next({
        path: "/detail",
        query,
        replace: true
      });
      return;
    }
  }

  next();
});

// 路由切换完成后统一刷新 head SEO 信息，避免页面各处重复维护。
router.afterEach((to) => {
  const seoConfig = getRouteSeoConfig(to);
  applySeo(seoConfig);
  // 可索引页面输出基础 WebPage 结构化数据；noindex 页面主动移除。
  if (String(seoConfig.robots).indexOf("noindex") > -1) {
    removeJsonLd("route-webpage");
    return;
  }
  setJsonLd("route-webpage", buildRouteJsonLd(to, seoConfig));
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js